import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  text-align: center;
  padding: 16px;
  box-sizing: border-box;

  sup {
    font-size: 12px;
  }
`;

export const Heading = styled.h2`
  font-size: 24px;
  color: ${props => props.theme.colors.heading};
`;

export const SubHeading = styled(Heading)`
  font-size: 18px;
`;

export const ContentFrame = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

export const Content = styled.div`
  font-size: 16px;
  padding: 8px 0;
  text-align: left;
  line-height: 1.5;

  img {
    max-width: 400px;
    display: inline-block;
    text-align: center;
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  margin: auto;
`;

export const TopIcon = styled.div`
  padding-bottom: 20px;
`;

export const Tnc = styled.div`
  font-size: 8px;
`;

export const PopupBottomDecoWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  height: 12.5vh;
`;

export const PopupBottomDeco = styled.div`
  position: relative;
  height: 25vh;

  &:before {
    position: absolute;
    left: 0;
    bottom: 12.5vh;
    display: block;
    width: 100%;
    height: 100%;
    content: ' ';
    background-color: white;
    transform: skew(-80deg);

    @media only screen and (min-width: 700px) {
      transform: skew(-88deg);
    }
  }
`;